import React from 'react';
import GieCard from "../GIECard/GieCard";

export default class NoticeForList extends React.Component<any, any> {
  render() {
    const {text, ...props} = this.props;
    return (
      <GieCard width="100%" height="inherit" {...props}>
        <div className="fw-bold py-2">{this.props.text}</div>
        {this.props.text2 && <div className="fw-bold py-2">{this.props.text2}</div>}
      </GieCard>
    );
  }
}
